/** Canonical origin for public URLs (must match production hostname). */
export const SITE_ORIGIN = 'https://storeel.com'

export interface RouteSeoMeta {
	title?: string
	description?: string
}

export function canonicalUrlForPath(path: string): string {
	if (path === '/' || path === '') return SITE_ORIGIN
	const withLeadingSlash = path.startsWith('/') ? path : `/${path}`
	const withoutTrailingSlash =
		withLeadingSlash.length > 1 ? withLeadingSlash.replace(/\/+$/, '') : withLeadingSlash
	return `${SITE_ORIGIN}${withoutTrailingSlash}`
}

function setMetaBySelector(selector: string, content: string) {
	const el = document.head.querySelector<HTMLMetaElement>(selector)
	if (el) el.setAttribute('content', content)
}

export function applyRouteDocumentMeta(path: string, meta: RouteSeoMeta) {
	const url = canonicalUrlForPath(path)
	const link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')
	if (link) link.setAttribute('href', url)
	setMetaBySelector('meta[property="og:url"]', url)

	if (meta.title) {
		document.title = meta.title
		setMetaBySelector('meta[property="og:title"]', meta.title)
		setMetaBySelector('meta[name="twitter:title"]', meta.title)
	}
	if (meta.description) {
		setMetaBySelector('meta[name="description"]', meta.description)
		setMetaBySelector('meta[property="og:description"]', meta.description)
		setMetaBySelector('meta[name="twitter:description"]', meta.description)
	}
}
